import { dispatch } from './internal.js';
import { isLoaded } from './Loadable/helpers.js';
import * as loadableUtils from './Loadable/utils.js';
export const actionStates = {
    START: 'START',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
export const dispatchFetchSuccessAction = (res, actionName, actionData = {}, callback) => {
    if (callback) {
        callback();
    }
    dispatch({
        type: `${actionName}_${actionStates.SUCCESS}`,
        payload: {
            ...actionData,
            res: loadableUtils.createLoaded(res),
        },
    });
};
export const dispatchFetchErrorAction = (err, actionName, actionData = {}, isPartial = false) => {
    dispatch({
        type: `${actionName}_${actionStates.ERROR}`,
        payload: {
            ...actionData,
            res: isPartial
                ? loadableUtils.createPartialError([], err)
                : loadableUtils.createError(err),
        },
    });
};
export const fetchLoadable = async (actionName, apiCall, actionData = {}, isPartial = false, callback) => {
    dispatch({
        type: `${actionName}_${actionStates.START}`,
        payload: {
            ...actionData,
            res: isPartial
                ? loadableUtils.createPartialLoading({ ...actionData })
                : loadableUtils.createLoading(),
        },
    });
    try {
        const response = await apiCall(...Object.values(actionData));
        dispatchFetchSuccessAction(response, actionName, actionData, callback);
        return response;
    }
    catch (err) {
        dispatchFetchErrorAction(err, actionName, actionData, isPartial);
        throw err;
    }
};
export const setPartialFetchStartState = (currentState, newState, listFieldName) => {
    return isLoaded(currentState)
        ? {
            loadingState: newState.loadingState,
            data: {
                ...currentState.data,
            },
        }
        : {
            loadingState: newState.loadingState,
            data: {
                ...newState.data,
                [listFieldName]: [],
            },
        };
};
export const setFetchStartState = (currentState, newState) => {
    return isLoaded(currentState)
        ? loadableUtils.createReloading(currentState.data)
        : newState;
};
//# sourceMappingURL=fetchLoadable.js.map